import {Injectable} from '@angular/core';
import {Configuration, HttpClientCustom} from '../../../shared';
import {BiUrls} from '../../biUrls';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class MDMService {

    public base_url: string = this._global.get('EPMS_BASE_URL') + 'v1/';
    public pageAuthList: any = [];
    public roles: any = [];
    public dimensions: any;
    public isBIAdmin: boolean = false;
    public referencePage: any;
    public referenceLastPage: any;
    public referencePageSize: number;
    static ERROR: string = 'error';
    static SUCCESS: string = 'success';
    static WARNING: string = 'warning';
    public roleId = [];
    public roleName : string ;
    constructor(public mdmService: HttpClientCustom, public _global: Configuration) {

    }

    onStartUp(path) {
        console.log('ON STARTUP---SERVICE');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        let objectList: any = [];
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '/';
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    save(path, objectData) {
        console.log('ON SAVE---SERVICE');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '/';
            self.mdmService.post(url, objectData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    search(path: string, searchUrlPath, regexData: string, page?: number, size?: number) {
        console.log('ON SEARCH --- SERVICE');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        let url;
        if (page == undefined && size == undefined) {
            url = self.base_url + path + searchUrlPath + regexData;
        } else {
            url = self.base_url + path + searchUrlPath + regexData + '&page=' + page + '&size=' + size;
        }
        return new Promise<any>((resolve, reject) => {            
            self.mdmService.post(url, null).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }
    
    search1(path: string, searchUrlPath, regexData: string): Observable<any> {
        let self = this;
        // let path1 = path;
        // path = self.updatePath(path1);
        let url = self.base_url + path + searchUrlPath + regexData;
        // self.isBIAdmin = false;
        return Observable.create((observer: any) => {
            let obs = Observable.forkJoin([self.mdmService.post(url, null)]);
            obs.subscribe((response: any) => {
                if (response[0] != undefined && response[0].success && response[0].data != undefined) {
                    observer.next(response[0].data);
                } else {
                    observer.next([]);
                }
                observer.complete();
            });
        });
    }

    bulkUpload(path: string, bulkUploadUrlPath, formData) {
        console.log('ON BULK UPLOAD --- SERVICE');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + bulkUploadUrlPath;
            self.mdmService.filePost(url, formData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    delete(path, id) {
        console.log('ON DELETE---SERVICE');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '/' + id;
            self.mdmService.delete(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    deleteModel(path, cubeId, recFormatId, dataSourceId) {
        console.log('ON DELETE---SERVICE');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '?cId=' + cubeId + "&rId=" + recFormatId + "&dId=" + dataSourceId;
            self.mdmService.delete(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    update(path, objectData) {
        console.log('ON EDIT---SERVICE');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '/';
            self.mdmService.put(url, objectData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    testConnection(path, DSdata){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.post(url, DSdata).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    getObjectById(path) {
        let object = {};
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.get(url).subscribe(res => {
                // object = res;
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    syncDataSource(id) {
        let self = this;
        let path1 = BiUrls.SYNC_DATASOURCE + id;
        let path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise<any>((resolve, reject) => {

            this.mdmService.get(path).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    syncAllRecordFormatsInDataSource(id) {
        let self = this;
        let path1 = BiUrls.SYNC_ALL_RF_DATASOURCE + id;
        let path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise<any>((resolve, reject) => {

            this.mdmService.get(path).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    syncRecordFormat(id) {
        let self = this;
        let path1 = BiUrls.SYNC_RECORD_FORMAT + id;
        let path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise<any>((resolve, reject) => {
            this.mdmService.get(path).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    updatePath(path) {
        let self = this;
        if (self.isBIAdmin) {
            return BiUrls.BIADMIN + '/' + path;
        } else {
            return path;
        }

    }

    getDataByPage(path: string, page: number, size: number) {
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '?page=' + page + '&size=' + size;
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        })
    }

    getRoleData(url: string){
        let self = this;
        return new Promise<any>((resolve) => {
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        })
    }

    getDataById(path: string, id: number) {
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '/' + id;
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        })
    }

    getDimensionByMeasureId(path,id){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + id;
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        })
    }

    loadPageAuthorizations(path, empIdList, pageId) {
        console.log('ON LOAD PAGE AUTHORIZATION SERVICE ----------');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        self.pageAuthList = [];
        let url = self.base_url + path + pageId;
        return new Promise<any>((resolve, reject) => {
            self.mdmService.post(url, empIdList).subscribe(res => {
                resolve(res);
            }, err => {
                resolve(err);
                console.log(err);
            });
        })
    }

    loadRoleAuthorizations(url, roleId){
        let self = this;
        return new Promise<any>((resolve, reject) => {
            self.mdmService.post(url,roleId).subscribe(res => {
                resolve(res);
            }, err => {
                resolve(err);
                console.log(err);
            });
        })
    }

    getRoleWidgets(url, roleIdList){
        let self = this;
        return new Promise<any>((resolve, reject) => {
            self.mdmService.post(url, roleIdList).subscribe(res => {
                resolve(res);
            }, err => {
                resolve(err);
                console.log(err);
            });
        })
    }

    setRoleId(id, name){
        this.roleId.push(id);
        this.roleName = name;
    }

    onSaveOrUpdate(path, pageAuthList) {
        console.log('ON SAVE OR UPDATE SERVICE ------------------');
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        let toBeAdded: any = [];
        let toBeUpdated: any = [];
        let url = self.base_url + path;
        return new Promise<any>((resolve, reject) => {
            self.mdmService.post(url, pageAuthList).subscribe(res => {
                resolve(res);
            }, err => {
                //resolve(err);
                reject(err);
                console.log(err);
            });
        });
    }

    async onUpdateRoleAuth(url, psIdList){
        let self = this;
        return new Promise<any>((resolve, reject) => {
            self.mdmService.post(url, psIdList).subscribe(res => {
                if(res){
                    resolve(res);
                }
            }, err => {
                reject(err);
                console.log(err);
            });
        });
    }
    

    getDimLevelValues(dimLvlObj) {
        let self = this;
        let path1 = String('../' + BiUrls.GET_DIM_LVL_VALUE);
        let path = self.updatePath(path1);
        path = self.base_url + path;
        console.log('GET DIMENSION LEVEL VALUE SERVICE .....');
        return new Promise<any>((resolve, reject) => {
            self.mdmService.post(path, dimLvlObj).subscribe(res => {
                resolve(res);
            }, err => {
                reject(err);
            });
        });
    }

    deleteEmpOrgDimRel(path, data) {
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        let url = self.base_url + path;
        return new Promise<any>((resolve, reject) => {
            self.mdmService.post(url, data).subscribe(res => {
                resolve(res);
            }, err => {
                reject(err);
            });
        });
    }

    async roleCheck() {
        console.log('ROLE CHECK SERVICE ......');
        let self = this;
        self.roles = await self.getObjectById(BiUrls.GET_OPERATIONS_FOR_USER);
        self.isBIAdmin = self.roles.includes('ROLE_BI_ADMIN');
        console.log('BI-ADMIN : ' + self.isBIAdmin);
    }

    getAll(path) {
        let self = this;
        path = self.updatePath(path);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '/';
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            });
        });
    }

    uploadFileToDrill(path, formData, dataSource) {
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '?dataSourceId=' + dataSource;
            self.mdmService.filePost(url, formData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    clearCache(path) {
        let self = this;
        path = self.updatePath(path);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.put(url, null).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    reUploadDrillFile(path, formData, dataSource) {
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '?recordFormatId=' + dataSource;
            self.mdmService.filePost(url, formData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    getEmployee(searchData) {
        return new Promise<any>((resolve) => {
            try {
                let self = this;
                let url = self.base_url + "webAdmin/employee";
                
                //let path1 = "page/getSearchedEmp";
                //let path = self.updatePath(path1);
                //let url = self.base_url + path;
                //let url = self.base_url + "biAdmin/empSearch";
                self.mdmService.post(url, searchData).subscribe((result) => {
                        resolve(result);
                });
            } catch (e) {
                console.log("getAllEmployeeData error catch", e);
            }
        })
    }

    uploadFileToDrillForWizard(path, formData, dataSource, uploadType) {
        let type = uploadType == true ? '?cubeId=' : '?dataSourceId=';
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + type + dataSource;
            self.mdmService.filePost(url, formData).subscribe(res => {
                resolve(res instanceof Object ? res : JSON.parse(res));
            }, err => {
                console.log(err);
                reject(err);
            })
        });
    }


    syncPrestoData(path, cubeId) {
        let type ='?cubeId=';
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + type + cubeId;
            self.mdmService.post(url, null).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                reject(err);
            })
        });
    }

    uploadDataSourceForPresto(path, dataSource){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + dataSource;
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    createAnalyticalModelPresto(path, rfData){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path ;
            self.mdmService.post(url,rfData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    saveFileForDesigner(path, cubeData) {
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.post(url, cubeData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    analyticalModelPreview(path, ModelData){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve) => {
            let url = self.base_url + path;
            self.mdmService.post(url,ModelData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    syncCacheConfig(path){
        let self = this;
        let path1 = BiUrls.CACHE + path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.put(url,null).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    flushCacheConfig(path){
        let self = this;
        let path1 = BiUrls.CACHE + path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.delete(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    dimensionData(dimensionData): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            let url = this.base_url + 'bi/adhoc/dimension';
            this.mdmService.post(url, dimensionData).toPromise().then((res) => {
                resolve(res);
            }, err => {
                console.error(err);
                reject(err);
            });
        });
    }

    getProgress(token,path){
        let url = 'page/bulkUpload/'+path+token;
        url = this.updatePath(url);
        url =  this.base_url + url;
        return new Promise<any>((resolve, reject) => {
            this.mdmService.get(url).toPromise().then((res) => {
                resolve(res);
            }, err => {
                console.error(err);
                reject(err);
            });
        });
    }

    getTimeDimension(measureIdList) {
        let self = this;
        return new Promise<any>((resolve, reject) => {
          let url = self.base_url + 'bi/dimension/getDim?isDimTime=true';
          self.mdmService.post(url, measureIdList).toPromise().then(res => {
            resolve(res);
          }), err => {
            reject(err);
          }
        });
    }

    createDataPoint(path, oData, type){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path ;
            self.mdmService[type](url,oData).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    getAllDataPointsByDSid(path,id){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path + '/' +id ;
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    getRFfromDataPointId(path,id){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path +'?dataPointId=' + id + '&createTemporary=true' ;
            self.mdmService.get(url).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                reject(err);
            })
        });
    }

    createAnalyticalModelOdata(path,rfList,id){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path +'?dataPointId=' + id + '&createTemporary=true' ;
            self.mdmService.post(url,rfList).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    saveAnalyticalModelOdata(path,Odata){
        let self = this;
        let path1 = path;
        path = self.updatePath(path1);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.post(url,Odata).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }

    reBuildDashboardSnaphot(path) {
        let self = this;
        path = self.updatePath(path);
        return new Promise<any>((resolve, reject) => {
            let url = self.base_url + path;
            self.mdmService.post(url, null).subscribe(res => {
                resolve(res);
            }, err => {
                console.log(err);
                resolve(err);
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/services/mdmService.service.ts